import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { SuperAdminAuthContext } from '../../context/SuperAdminAuthContext.jsx';
import { showMessage } from '../../context/MessageContext.jsx';
import Input from '../../components/ui/Input.jsx';
import Button from '../../components/ui/Button.jsx';
import './SuperAdminLogin.css';

/**
 * SuperAdmin Login page component
 */
export default function SuperAdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useContext(SuperAdminAuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!username || !password) {
      showMessage('Please enter username and password.', 'error');
      return;
    }

    try {
      setLoading(true);
      await login(username, password);
      navigate('/superadmin');
    } catch (err) {
      setLoading(false);
      const errorMsg = err?.response?.data?.message || 'Login failed. Please check your credentials.';
      showMessage(errorMsg, 'error');
    }
  };

  return (
    <main className="superadmin-login-page">
      <div className="superadmin-login-container">
        {/* Logo and Heading */}
        <div className="superadmin-login-header">
          <img
            src="/images/logosetu.jpg"
            alt="SetuLink Logo"
            className="superadmin-login-logo"
          />
          <p className="superadmin-login-tagline">
            Super Admin Portal
          </p>
        </div>

        <div className="superadmin-login-title-section">
          <h3 className="superadmin-login-title">Super Admin Login</h3>
        </div>

        {/* Login Form */}
        <form onSubmit={handleSubmit} className="superadmin-login-form">
          <Input
            label="Username"
            id="username"
            name="username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Enter your username"
            required
            error={error}
          />

          <Input
            label="Password"
            id="password"
            name="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            required
          />

          <Button
            type="submit"
            variant="primary"
            fullWidth
            loading={loading}
            className="superadmin-login-submit-button"
          >
            {!loading && (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                  aria-hidden="true"
                >
                  <path d="M16 8a8 8 0 1 1-16 0 8 8 0 0 1 16 0zm-4.5-.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 .252.434l2.5 1.5a.5.5 0 0 0 .496-.868L11.5 10.5V7.5z" />
                </svg>
                Sign In
              </>
            )}
          </Button>
        </form>

        <p className="superadmin-login-footer">
          <a href="/" className="superadmin-login-link">
            Back to User Login
          </a>
        </p>
      </div>
    </main>
  );
}

